export const IndividualExcelHeaders = [
  { label: 'Id', key: 'id' },
  { label: 'District', key: 'ref_district.name' },
  // { label: 'ATOM ID', key: 'atom_id' },
  { label: 'First Name', key: 'first_name' },
  { label: 'Last Name', key: 'last_name' },
  { label: 'User Type', key: 'user_category_sub_type.sub_category_name' },
  { label: 'Date Of Birth', key: 'dob' },
  { label: 'Gender', key: 'gender' },
  { label: 'Email', key: 'email' },
  { label: 'Mobile', key: 'mobile' },
  { label: 'Address', key: 'address' },
  { label: 'Identity Type', key: 'identity_type' },
  { label: 'Identity Card', key: 'identity_card' },
  { label: 'Kit Size', key: 'kit_size' },
  { label: 'Shoe Size', key: 'shoe_size' },
  { label: 'Level of Achievement', key: 'athlete_level' },
  { label: 'Father Name', key: 'father_name' },
  { label: 'Mother Name', key: 'mother_name' },
  { label: 'Date Of Joining', key: 'date_of_joining_training_centre' },
  { label: 'Organization Type', key: 'orgnization_type' },
  { label: 'Organization Name', key: 'orgnization_name' },
];